import { Route, Routes } from 'react-router-dom';

import ComposableDashboardContextProvider from '../../../../features/analyticsPage/context/ComposableDashboardContext';
import ComposableDashboardFiltersContextProvider from '../../../../features/analyticsPage/context/ComposableDashboardFiltersContext';
import ComposableDynamicListingContextProvider from '../../../../features/analyticsPage/context/ComposableDynamicListingContext';
import ComposableDashboardsCollectionsContextProvider from '../../../analyticsPage/context/ComposableDashboardsCollectionContext';
import BrowserExtension from '../fAQs/components/browserExtension/BrowserExtension';
import Candidates from '../fAQs/components/candidates/Candidates';
import DataPrivacy from '../fAQs/components/dataPrivacy/DataPrivacy';
import Jobs from '../fAQs/components/jobs/Jobs';
import TeamOwners from '../fAQs/components/teamOwners/TeamOwners';
import { MfaAuthenticator } from '../mfaAuthenticator';
import MyActivity from '../myActivity/MyActivity';
import SettingNewPassword from '../settingNewPassword/SettingNewPassword';
import Profile from '../userProfile/Profile';
import UserProfileIndex from '../userProfileIndex/UserProfileIndex';
import Workspace from '../workspaceInfo/Workspace';

export const RecruiterProfileRoutes = () => (
  <Routes>
    <Route
      path="/profile"
      element={
        <ComposableDynamicListingContextProvider>
          <ComposableDashboardContextProvider>
            <ComposableDashboardsCollectionsContextProvider>
              <ComposableDashboardFiltersContextProvider>
                <Profile />
              </ComposableDashboardFiltersContextProvider>
            </ComposableDashboardsCollectionsContextProvider>
          </ComposableDashboardContextProvider>
        </ComposableDynamicListingContextProvider>
      }
    />
    <Route path="/user-profile-index" element={<UserProfileIndex />} />
    <Route path="/workspace" element={<Workspace />} />
    <Route path="/activity" element={<MyActivity />} />
    <Route path="/password" element={<SettingNewPassword />} />
    <Route path="/mfa-authenticator" element={<MfaAuthenticator />} />

    <Route path="/faq" element={<Jobs />} />
    <Route path="/faq-candidates" element={<Candidates />} />
    <Route path="/faq-data-privacy" element={<DataPrivacy />} />
    <Route path="/faq-browser-extension" element={<BrowserExtension />} />
    <Route path="/faq-team-owners" element={<TeamOwners />} />
  </Routes>
);
